import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Header } from '../comp/Header'
import { ShoppingCart as ShoppingCartIcon, MapPin, Clock, Award, Users, Shield, Wrench, CheckCircle, CreditCard, Building2, Wallet, Truck, Package } from 'lucide-react'
import { Button } from '../Components/ui/button'
import { ImageWithFallback } from '../Components/figma/ImageWithFallback'
import { CartItem, ShoppingCart } from '../comp/ShoppingCart'
import Cookies from 'js-cookie'
import { catalogClient } from '../services/grpc'
import * as pb from '../generated/catalog_pb';
import { NewHeader } from '../comp/NewHeader'
import { Footer } from '../comp/Footer';
import Logo from "../comp/icons/Logo"
export function Delivery() {
  const [isCartOpen, setIsCartOpen] = useState(false)
 const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [cartItemCount, setCartItemCount]= useState(0);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');

const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const initializeApp = async () => {
    let isguid = Cookies.get('guid');
    if (typeof isguid != 'string') {
      const req= new pb.guidReq();  
     
      req.setIp(window.location.hostname);
      catalogClient.getGuid(req, {}, (err, response) => {
        if (err) {
          console.error('Error fetching guid:', err.code, err.message);
        } else {
          Cookies.set('guid', response.getGuid());
        }
      });
    }
    const guid = Cookies.get('guid');
   
    };
        const OnsetIsInCartStorage=(items:string[])=>{

  }
    const updateQuantity = (porodId: number, quantity: number,storage:string) => {
          try {
            if (quantity === 0) {
              removeFromCart(porodId,storage)
              return
            }
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
              const req = new pb.CartAddReq();
              req.setGuid(guid);
              req.setProductId(porodId);
              req.setQty(quantity);
              req.setStorage(storage);
              catalogClient.cartUpdate(req, {}, (err, response) => {
                if (err) {
                  console.error('Error adding to cart:', err.code, err.message);
                }
              });
            }
            setCartItems(prev => {
              const safeCartItems = prev || []
              return safeCartItems.map(item =>
                item.product.id === porodId  && item.storage === storage? { ...item, quantity,storage } : item
              )
            })
          } catch (error) {
            console.error('Error updating quantity:', error)
          }
        }
       
        const removeFromCart = (porodId: number,storage:string) => {
          try {
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
            const req = new pb.CartRemoveReq();
            req.setGuid(guid);
            req.setProductId(porodId);
            req.setQty(0);
            req.setStorage(storage);
            catalogClient.cartRemove(req, {}, (err, response) => {
              
              if (err) {
                console.error('Error removing from cart:', err.code, err.message);
              }
            });
          }
            setCartItems(prev => {
              const safeCartItems = prev || []
              return safeCartItems.filter(item => !(item.product.id === porodId && item.storage === storage))
            })
          } catch (error) {
            console.error('Error removing from cart:', error)
          }
        }
        
          const setOrder = ()=>{
              if (!customerName || !customerPhone) {
                setAlertMessage(`Пожалуйста. Введите Ваше имя и номер телефона для связи`);
                return;
            }
          
              const guid = Cookies.get('guid');
              if (typeof guid === 'string') {
                const req=new pb.OrderAcceptReq();
                req.setGuid(guid);
                req.setName(customerName);
                req.setPhone(customerPhone);
                catalogClient.orderAccept(req, {}, (err, response) => {
                  if (err) {
                    console.error('Error removing from cart:', err.code, err.message);
                  } else {
                  if (response.getStatus()=="fail") { 
                    setAlertMessage(`${response.getMessage()}`);
                  } else {
                    setAlertMessage(`Спасибо за заказ.\n\ 
                      В ближайшее время наш менеджер свяжется с Вами.\n\ 
                      Номер вашего заказа: ${response.getNum()}`);
                    setCartItems([]);
                    setIsCartOpen(false);
                  }
                    return;
                  }
                });
              }
            }
        
  return (
    <div className="min-h-screen bg-gray-50">
        <NewHeader
           cartItemCount={cartItemCount}
           onCartClick={() => setIsCartOpen(true)}
           onAccountClick={() => setIsAccountOpen(true)}
           searchQuery={searchQuery}
           onSearchChange={setSearchQuery}
           page='delivery'
         />
<div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-5xl mx-auto space-y-8">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Как получить заказ</h1>
          <p className="text-xl">Удобные способы доставки и оплаты</p>
        
          {/* Pickup Section */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-gradient-to-br from-blue-950 to-blue-800 text-white px-6 py-4 flex items-center gap-3">
              <Package className="h-6 w-6" />
              <h2 className="text-2xl font-bold">Самовывоз со склада</h2>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex items-start gap-4">
                <MapPin className="h-6 w-6 text-blue-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-lg mb-2">Адрес</h3>
                  <p className="text-gray-700 mb-2">Предпортовая улица, 8Т, Санкт-Петербург</p>
                  <p className="text-sm text-gray-500">Координаты: 59.834619, 30.301800</p>
                  <a
                    href={`https://yandex.ru/maps/?pt=30.301800,59.834619&z=16&l=map`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-2 text-blue-600 hover:text-blue-700 font-medium"
                  >
                    Открыть на карте →
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Clock className="h-6 w-6 text-blue-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-lg mb-2">График работы</h3>
                  <p className="text-gray-700">пн–пт 10:00–19:00</p>
                </div>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
                <p className="text-blue-900">
                  ⏱️ Заказ собирается в течение одного часа после подтверждения менеджера.
                </p>
              </div>
            </div>
          </div>

          {/* Courier Delivery */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-blue-600 text-white px-6 py-4 flex items-center gap-3 bg-gradient-to-br from-blue-950 to-blue-800">
              <Truck className="h-6 w-6" />
              <h2 className="text-2xl font-bold">Курьерская доставка</h2>
            </div>
            <div className="p-6">
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                <h3 className="font-semibold text-lg mb-2 text-orange-900">
                  По городу Санкт-Петербургу
                </h3>
                <p className="text-orange-700">В разработке.</p>
              </div>
            </div>
          </div>

          {/* Transport Company Delivery */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-blue-600 text-white px-6 py-4 flex items-center gap-3 bg-gradient-to-br from-blue-950 to-blue-800">
              <Truck className="h-6 w-6" />
              <h2 className="text-2xl font-bold">Транспортная компания по РФ</h2>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-gray-700">
                Отправляем через <span className="font-semibold">СДЭК, Деловые линии, ПЭК, Возовоз</span>.
              </p>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p className="text-gray-700 mb-2">
                  <span className="font-semibold">Оплата доставки:</span> Услуги ТК оплачивает покупатель при получении груза 
                  (по тарифам выбранной вами компании).
                </p>
                <p className="text-gray-700">
                  Мы лишь отправляем заказ и сразу сообщаем номер декларации, чтобы вы могли отслеживать доставку.
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="font-semibold text-blue-900">СДЭК</div>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="font-semibold text-blue-900">Деловые линии</div>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="font-semibold text-blue-900">ПЭК</div>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="font-semibold text-blue-900">Возовоз</div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Methods */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-gradient-to-br from-green-950 to-green-800 text-white px-6 py-4 flex items-center gap-3">
              <CreditCard className="h-6 w-6" />
              <h2 className="text-2xl font-bold">Способы оплаты</h2>
            </div>
            <div className="p-6">
              <div className="space-y-4">
                {/* Online Payment */}
                <div className="flex items-start gap-4 p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors">
                  <CreditCard className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Онлайн картой</h3>
                    <p className="text-gray-600">Visa / MasterCard / Мир</p>
                  </div>
                </div>

                {/* Bank Transfer */}
                <div className="flex items-start gap-4 p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors">
                  <Building2 className="h-6 w-6 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Банковский перевод</h3>
                    <p className="text-gray-600">На расчётный счёт (для юрлиц и ИП)</p>
                  </div>
                </div>

                {/* Cash */}
                <div className="flex items-start gap-4 p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors">
                  <Wallet className="h-6 w-6 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-lg mb-1">Наличные</h3>
                    <p className="text-gray-600">Только при самовывозе</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-br from-blue-950 to-blue-800 text-white rounded-xl shadow-lg p-8 ">
            <h2 className="text-2xl font-bold mb-4">Остались вопросы?</h2>
            <p className="text-blue-100 mb-6">
              Напишите в MAX-чат или позвоните по номеру — операторы на связи с 9:00 до 19:00 с пн по пт.
            </p>
            <div className="flex flex-col md:flex-row gap-4">
              <a
                href="tel:+79819656888"
                className="flex items-center justify-center gap-2 bg-white text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-lg font-semibold transition-colors"
              >
                <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                +7 981 965 68 88
              </a>
              <a
                href="https://max.ru/u/f9LHodD0cOJ5qf6iKgjiw99Fc04YQJ934KGXLGFiATMaYYA8jdDpsRJFMW4"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-white text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-lg font-semibold transition-colors"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                  d="M12.5 2C18.3 2 23 6.7 23 12.5C23 18.3 18.3 23 12.5 23C10.4 23 8.4 22.4 6.8 21.3L2.8 22.3C2 22.5 1.5 22 1.7 21.2L2.7 17.2C1.6 15.6 1 13.6 1 12.5C1 6.7 6.2 2 12.5 2ZM12.5 6.5C9.2 6.5 6.5 9.2 6.5 12.5C6.5 14 7 15.3 7.9 16.3L6 18L8.2 16.7C9.3 17.8 10.8 18.5 12.5 18.5C15.8 18.5 18.5 15.8 18.5 12.5C18.5 9.2 15.8 6.5 12.5 6.5Z"
                  fill="currentColor" fill-rule="evenodd" />
                </svg>
                MAX-чат
              </a>
            </div>
          </div>
        </div>
      </div>
    </div> 
       <Footer/>
       {Array.isArray(cartItems) && (
                          <ShoppingCart
                            isOpen={isCartOpen}
                            onOpenChange={setIsCartOpen}
                            cartItems={cartItems}
                            onUpdateQuantity={updateQuantity}
                            onRemoveItem={removeFromCart}
                            onOrder={setOrder}
                            customerName={customerName}
                            customerPhone={customerPhone}
                            setCustomerName={setCustomerName}
                            setCustomerPhone={setCustomerPhone}
                            setCartItemCount={setCartItemCount}
                            setIsInCartStorage={OnsetIsInCartStorage}
                          />
                        )}
    </div>
  )
}
